import Http from "./http";

export const ssoLyricUrlAPI = (data) => {
  return Http.post("sso/lyricUrl", data);
};
